import React from 'react';
import { useTheme } from '../context/ThemeContext';

const ThemeToggle = ({ className = '', floating = false }) => {
  const { themeMode, resolvedTheme, setThemeMode, setToSystem } = useTheme();

  const toggle = () => {
    setThemeMode(resolvedTheme === 'dark' ? 'light' : 'dark');
  };

  const wrapClass = floating
    ? `absolute top-4 right-4 z-10 flex items-center gap-2 ${className}`
    : `flex items-center gap-2 ${className}`;

  return (
    <div className={wrapClass}>
      <button
        type="button"
        onClick={toggle}
        className="rounded px-2.5 py-1 text-xs font-medium text-zinc-500 border border-zinc-200 hover:text-zinc-900 hover:border-zinc-400 transition-colors dark:border-white/[0.06] dark:hover:text-white dark:hover:border-white/[0.12]"
        aria-label={
          resolvedTheme === 'dark'
            ? 'Switch to light appearance'
            : 'Switch to dark appearance'
        }
      >
        {resolvedTheme === 'dark' ? '☀' : '☾'}
      </button>
      {themeMode !== 'system' && (
        <button
          type="button"
          onClick={setToSystem}
          className="text-[10px] font-medium text-zinc-400 uppercase tracking-wider hover:text-zinc-700 transition-colors dark:text-zinc-600 dark:hover:text-zinc-400"
        >
          Auto
        </button>
      )}
    </div>
  );
};

export default ThemeToggle;
